import { render, staticRenderFns } from "./CmRole.vue?vue&type=template&id=0941445c&scoped=true"
import script from "./CmRole.vue?vue&type=script&lang=js"
export * from "./CmRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0941445c",
  null
  
)

export default component.exports